import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { s as slotFilled } from './index3.js';
import { d as defineCustomElement$7 } from './box.js';
import { d as defineCustomElement$6 } from './form-field.js';
import { d as defineCustomElement$5 } from './icon.js';
import { d as defineCustomElement$4 } from './toggle.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const expandableToggleCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border-radius:.375rem;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host(:not([nested])){border:1px solid var(--jw-theme-surface-border-border-color)}:host(:not([nested])) .header{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-default-color)}:host(:not([nested])) .header-description{color:var(--jw-theme-surface-text-description-color)}:host(:not([nested])) wui-icon{margin-top:.25rem}:host(:not([nested])) h3{font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem}:host(:not([nested])) .body{background-color:var(--jw-theme-surface-elevated-default-bg-color)}:host([nested]) .header{background-color:var(--jw-theme-surface-level1-default-bg-color)}:host([nested]) .header-description{color:var(--jw-theme-surface-text-description-color)}:host([nested]) wui-icon{margin-top:.125rem}:host([nested]) h3{font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}:host([nested]) .body{background-color:var(--jw-theme-surface-level1-default-bg-color)}.header{border-radius:.375rem;gap:1rem;padding:1rem;transition:border-radius .35s ease,background-color .35s ease,color .35s ease}.header,.header-container{display:flex;flex-direction:column}.header-container{gap:.125rem}.header-description{font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}wui-icon{align-self:flex-start}.title{gap:2rem;justify-content:space-between}.icon-title,.title{align-items:center;display:flex}.icon-title{flex:1;flex-direction:row;gap:.5rem}h3{margin:0;padding:0}.body{border-radius:.375rem;display:none;padding:1rem;transition:border-radius .35s ease}:host([checked]) .header{background-color:var(--jw-theme-info-muted-message-bg-color);color:var(--jw-theme-info-muted-message-color)}:host([checked]) .header:has(+.body){border-bottom-left-radius:0;border-bottom-right-radius:0}:host([checked]) .body{border-top-left-radius:0;border-top-right-radius:0;display:flex}:host([disabled]) .header{background-color:var(--jw-theme-neutral-muted-message-bg-color);color:var(--jw-theme-form-field-disabled-color);cursor:not-allowed}:host([disabled]) .header-description{color:var(--jw-theme-surface-text-description-color);cursor:not-allowed}:host([disabled]) .description{color:var(--jw-theme-surface-text-description-color);cursor:not-allowed}";
const WuiExpandableToggleStyle0 = expandableToggleCss;

const WuiExpandableToggle$1 = /*@__PURE__*/ proxyCustomElement(class WuiExpandableToggle extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.checked = undefined;
        this.header = undefined;
        this.headerDescription = undefined;
        this.disabled = false;
        this.disabledMsg = undefined;
        this.iconName = undefined;
        this.nested = false;
    }
    toggle(checked = !this.checked) {
        if (this.disabled) {
            return;
        }
        this.checked = checked;
        this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
    }
    render() {
        return (h(Host, { key: '80b642a5c87d208d161b54e3b38c7265ad14cb42' }, h("div", { key: 'd13c53e3cc6fb9559fdf73ce289635921c65ca82', class: "header" }, h("div", { key: '9b8e7edc62434d9d60dbb9fb6cc64c6367fc942d', class: "title" }, h("div", { key: 'c6c653ca25c767cc8e8121958ea441b9ef48b90e', class: "icon-title" }, this.iconName && h("wui-icon", { key: '5ec2e1b7cd57700353970e1702eaf6fd51d6e06d', name: this.iconName }), h("div", { key: '5a61e5796d6e6aa01f2ef78ef4a0050402ebd354', class: "header-container" }, h("h3", { key: '1e9d0886693f9aaaa5c604b8d6e8a4ca8d9e009f' }, this.header), this.headerDescription && h("div", { key: '09423274073a29a0c1775d96a1fe7ea42f53212c', class: "header-description" }, this.headerDescription))), h("wui-toggle", { key: '26a11ddb007b76c11125ed779cdb1aeac3afd544', onInput: (e) => {
                const target = e.currentTarget;
                // Emit our own event
                e.preventDefault();
                e.stopPropagation();
                this.toggle(target?.checked);
            }, checked: this.checked, disabled: Boolean(this.disabled), "data-test": "set-toggle-value" })), this.disabledMsg && (h("div", { key: 'c5264aa6e10b7337cb07b9a722d794d9164b77ed', class: "description", "data-test": "show-toggle-disabled-warning" }, this.disabledMsg))), slotFilled(this.elm) && (h("div", { key: 'd5cdb5d301e87bc504218c30d2a26c7eae6d7fef', class: "body" }, h("slot", { key: '52d782f0b2c979cc2a3e9e29fce64d5fe10ae838' })))));
    }
    get elm() { return this; }
    static get style() { return WuiExpandableToggleStyle0; }
}, [1, "wui-expandable-toggle", {
        "checked": [1540],
        "header": [1],
        "headerDescription": [1, "header-description"],
        "disabled": [516],
        "disabledMsg": [1, "disabled-msg"],
        "iconName": [1, "icon-name"],
        "nested": [516]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-expandable-toggle", "wui-box", "wui-form-field", "wui-icon", "wui-toggle", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-expandable-toggle":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiExpandableToggle$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-toggle":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiExpandableToggle = WuiExpandableToggle$1;
const defineCustomElement = defineCustomElement$1;

export { WuiExpandableToggle, defineCustomElement };

//# sourceMappingURL=wui-expandable-toggle.js.map